import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem("neurotheos_token", data.token);
      localStorage.setItem("neurotheos_email", data.email);
      nav("/admin");
    } catch (err) {
      setError(err?.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: "linear-gradient(180deg,#fbf8f1 0%,#f4ecd8 100%)" }} data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-md rounded-3xl p-10" style={{ background: "#fbf8f1", border: "1px solid var(--line)", boxShadow: "0 30px 80px -30px rgba(60,50,20,0.2)" }}>
        <div className="text-center mb-8">
          <div className="serif" style={{ fontSize: 36, letterSpacing: "0.01em" }}>Brain Trainer</div>
          <div className="eyebrow mt-2">Admin Sign-in</div>
        </div>
        <div className="mb-5">
          <label className="label-soft">Email</label>
          <input className="input-field" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" />
        </div>
        <div className="mb-6">
          <label className="label-soft">Password</label>
          <input className="input-field" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" />
        </div>
        {error && <div className="mb-4 text-sm" style={{ color: "#a94442" }} data-testid="login-error">{error}</div>}
        <button type="submit" className="btn-pill btn-dark w-full" disabled={loading} data-testid="login-submit">
          {loading ? "..." : "Sign in"}
        </button>
        <div className="mt-6 text-center">
          <a href="/" className="text-xs uppercase tracking-widest" style={{ color: "var(--ink-muted)" }}>← Back to site</a>
        </div>
      </form>
    </div>
  );
}
